import logger from 'utils/logger.util';

const L = logger('setRef');

const setRef = (ref, val) => {
  try {
    if (!ref) {
      return void L.debug('Invalid ref:', ref);
    }

    // eslint-disable-next-line no-param-reassign
    ref.current = val;

    return ref.current;
  } catch (e) {
    L.warn('()', e);
    return void 1;
  }
};

// noinspection JSUnusedGlobalSymbols
export default setRef;
